export default function ContactForm({
    formData,
    errors,
    loading,
    onChange,
    onSubmit,
    title = "Send Us a Message",
}) {
    return (
        <div className="contact-form">
            <h2>{title}</h2>

            <form onSubmit={onSubmit} noValidate>
                <div className="form-row two-column">
                    <Input
                        name="first_name"
                        value={formData.first_name}
                        onChange={onChange}
                        error={errors.first_name}
                    />
                    <Input
                        name="last_name"
                        value={formData.last_name}
                        onChange={onChange}
                        error={errors.last_name}
                    />
                </div>

                <div className="form-row two-column">
                    <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={onChange}
                        error={errors.email}
                    />
                    <Input
                        name="mobile"
                        value={formData.mobile}
                        onChange={onChange}
                        error={errors.mobile}
                    />
                </div>

                <div className="form-row full-width">
                    <select
                        name="category"
                        value={formData.category}
                        onChange={onChange}
                    >
                        <option value="">Category</option>
                        <option>Bulk Enquiry / Corporate Order</option>
                        <option>Order Cancellation</option>
                        <option>Return & Exchange</option>
                        <option>Careers</option>
                        <option>Others</option>
                    </select>
                    {errors.category && (
                        <p className="error-text">{errors.category}</p>
                    )}
                </div>

                <div className="form-row full-width">
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={onChange}
                        placeholder="Message"
                    />
                    {errors.message && (
                        <p className="error-text">{errors.message}</p>
                    )}
                </div>

                <button type="submit" disabled={loading}>
                    {loading ? "Submitting..." : "SEND MESSAGE"}
                </button>
            </form>
        </div>
    );
}

/* ---------------- INPUT COMPONENT ---------------- */

function Input({ name, value, onChange, error, type = "text" }) {
    return (
        <div>
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={name.replace("_", " ")}
            />
            {error && <p className="error-text">{error}</p>}
        </div>
    );
}
